import { getRetailUnitAndLanguage } from '../network/utils/getRetailUnitAndLanguage';
import { getEnv } from './env';
const { retailUnit } = getRetailUnitAndLanguage();

interface Deployments {
  [key: string]: (typeof env)[];
}

const RETAIL_UNITS_WITH_CIAM: Deployments = {
  kw: ['development', 'qa', 'production'],
  lv: ['development', 'qa', 'production'],
  lt: ['development', 'qa', 'production'],
  ee: ['development', 'qa', 'production'],
};

const RETAIL_UNITS_WITH_GUEST_TOKEN: Deployments = {
  lv: ['development', 'qa', 'production'],
  lt: ['development', 'qa', 'production'],
  ee: ['development', 'qa', 'production'],
};

const env = getEnv();

export const isCiamEnabled = RETAIL_UNITS_WITH_CIAM?.[retailUnit]?.includes(env);
export const isGuestTokenEnabled = RETAIL_UNITS_WITH_GUEST_TOKEN?.[retailUnit]?.includes(env);
